import { CorporateViewTabs } from '../hubNavTabs';

/** Hub / Planning query params for FOC 10.1–12.4 Planning P tours. */
export const FOC_PLANNING_P_MODEL_TOUR_PARAM = 'focPlanningPModelTour';
export const FOC_PLANNING_P_MEETING_TOUR_PARAM = 'focPlanningPMeetingTour';
export const FOC_PLANNING_P_COMMAND_STAFF_TOUR_PARAM =
  'focPlanningPCommandStaffTour';
export const FOC_PLANNING_P_PREP_TACTICS_TOUR_PARAM =
  'focPlanningPPrepTacticsTour';
export const FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_PARAM =
  'focPlanningPTacticsWorkflowTour';
export const FOC_PLANNING_P_TACTICS_MEETING_TOUR_PARAM =
  'focPlanningPTacticsMeetingTour';
export const FOC_PLANNING_PREP_TOUR_PARAM = 'focPlanningPrepTour';
export const FOC_IAP_PREP_TOUR_PARAM = 'focIapPrepTour';
export const FOC_IAP_FORMS_TOUR_PARAM = 'focIapFormsTour';

export type FocPlanningPTourKey =
  | 'model'
  | 'meeting'
  | 'commandStaff'
  | 'prepTactics'
  | 'tacticsWorkflow'
  | 'tacticsMeeting'
  | 'prepPlanning'
  | 'iapPrep'
  | 'iapForms';

export type FocPlanningPTourEntry = {
  key: FocPlanningPTourKey;
  param: string;
  /** 1-indexed dashboard phase query value. */
  phase: number;
  /** Dynamic import path for the tour starter module. */
  importTour: () => Promise<{
    startTour: () => void;
    waitForSelector: (
      selector: string,
      timeoutMs?: number
    ) => Promise<boolean>;
  }>;
};

function hubHref(param: string): string {
  return `/hub?openTab=${CorporateViewTabs.Incidents}&${param}=1`;
}

export const FOC_PLANNING_P_MODEL_TOUR_HREF = hubHref(
  FOC_PLANNING_P_MODEL_TOUR_PARAM
);
export const FOC_PLANNING_P_MEETING_TOUR_HREF = hubHref(
  FOC_PLANNING_P_MEETING_TOUR_PARAM
);
export const FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF = hubHref(
  FOC_PLANNING_P_COMMAND_STAFF_TOUR_PARAM
);
export const FOC_PLANNING_P_PREP_TACTICS_TOUR_HREF = hubHref(
  FOC_PLANNING_P_PREP_TACTICS_TOUR_PARAM
);
export const FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_HREF = hubHref(
  FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_PARAM
);
export const FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF = hubHref(
  FOC_PLANNING_P_TACTICS_MEETING_TOUR_PARAM
);
export const FOC_PLANNING_PREP_TOUR_HREF = hubHref(FOC_PLANNING_PREP_TOUR_PARAM);
export const FOC_IAP_PREP_TOUR_HREF = hubHref(FOC_IAP_PREP_TOUR_PARAM);
export const FOC_IAP_FORMS_TOUR_HREF = hubHref(FOC_IAP_FORMS_TOUR_PARAM);

export const FOC_PLANNING_P_TOUR_ENTRIES: readonly FocPlanningPTourEntry[] = [
  {
    key: 'model',
    param: FOC_PLANNING_P_MODEL_TOUR_PARAM,
    phase: 1,
    importTour: () =>
      import('./focPlanningPModelTour').then((m) => ({
        startTour: m.startFocPlanningPModelTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'meeting',
    param: FOC_PLANNING_P_MEETING_TOUR_PARAM,
    phase: 1,
    importTour: () =>
      import('./focPlanningPMeetingTour').then((m) => ({
        startTour: m.startFocPlanningPMeetingTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'commandStaff',
    param: FOC_PLANNING_P_COMMAND_STAFF_TOUR_PARAM,
    phase: 2,
    importTour: () =>
      import('./focPlanningPCommandStaffTour').then((m) => ({
        startTour: m.startFocPlanningPCommandStaffTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'prepTactics',
    param: FOC_PLANNING_P_PREP_TACTICS_TOUR_PARAM,
    phase: 3,
    importTour: () =>
      import('./focPlanningPPrepTacticsTour').then((m) => ({
        startTour: m.startFocPlanningPPrepTacticsTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'tacticsWorkflow',
    param: FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_PARAM,
    phase: 3,
    importTour: () =>
      import('./focPlanningPTacticsWorkflowTour').then((m) => ({
        startTour: m.startFocPlanningPTacticsWorkflowTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'tacticsMeeting',
    param: FOC_PLANNING_P_TACTICS_MEETING_TOUR_PARAM,
    phase: 4,
    importTour: () =>
      import('./focPlanningPTacticsMeetingTour').then((m) => ({
        startTour: m.startFocPlanningPTacticsMeetingTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'prepPlanning',
    param: FOC_PLANNING_PREP_TOUR_PARAM,
    phase: 5,
    importTour: () =>
      import('./focPlanningPrepTour').then((m) => ({
        startTour: m.startFocPlanningPrepTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'iapPrep',
    param: FOC_IAP_PREP_TOUR_PARAM,
    phase: 7,
    importTour: () =>
      import('./focIapPrepTour').then((m) => ({
        startTour: m.startFocIapPrepTour,
        waitForSelector: m.waitForSelector,
      })),
  },
  {
    key: 'iapForms',
    param: FOC_IAP_FORMS_TOUR_PARAM,
    phase: 7,
    importTour: () =>
      import('./focIapFormsTour').then((m) => ({
        startTour: m.startFocIapFormsTour,
        waitForSelector: m.waitForSelector,
      })),
  },
];

export function findFocPlanningPTourEntryByParam(
  searchParams: URLSearchParams
): FocPlanningPTourEntry | null {
  for (const entry of FOC_PLANNING_P_TOUR_ENTRIES) {
    if (searchParams.get(entry.param) === '1') return entry;
  }
  return null;
}
